import { createStyles } from 'antd-style';

const useWorkspacePopoverStyles = createStyles(({ token, css }) => ({
  popover: css`
    width: 229px;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    padding: 0;
  `,
  header: css`
    display: flex;
    align-items: center;
    padding: 16px 16px 8px 16px;
  `,
  avatar: css`
    background: #D9D9D9 !important;
    margin-right: 12px;
    width: 40px !important;
    height: 40px !important;
    font-size: 18px !important;
  `,
  info: css`
    display: flex;
    flex-direction: column;
  `,
  name: css`
    font-weight: 600;
    font-size: 12px;
    color: #000;
  `,
  email: css`
    font-weight: 300;
    font-size: 10px;
    color: #000;
  `,
  divider: css`
    height: 1px;
    background: #05042E;
    margin: 12px 0 8px 0;
    opacity: 0.08;
  `,
  actions: css`
    padding: 0 8px 8px 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,
  actionRow: css`
    display: flex;
    align-items: center;
    border-radius: 2px;
    padding: 6px 8px;
    cursor: pointer;
    transition: background 0.18s;
    &:hover {
      background: #f5f5f5;
    }
  `,
  actionRowNoHover: css`
    display: flex;
    align-items: center;
    border-radius: 2px;
    padding: 6px 8px;
    cursor: default;
  `,
  icon: css`
    display: flex;
    align-items: center;
    margin-right: 8px;
  `,
  actionText: css`
    font-size: 14px;
    color: #09090B;
    flex: 1;
  `,
  authBtn: css`
    background: #8C34FF;
    color: #fff;
    border: none;
    border-radius: 30px;
    padding: 0 14px;
    height: 22px;
    font-size: 12px;
    cursor: pointer;
    transition: background 0.18s;
    &:hover {
      background: #a46cff;
    }
  `,
}));

export default useWorkspacePopoverStyles; 